var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 8H5m0 4h9m-3 4H5m10 0h6m-3-3v6"
    }, null, -1)
  ]));
}
__name(render, "render");
const playlistAdd = markRaw({ name: "tabler-playlist-add", render });
export {
  playlistAdd as default
};
//# sourceMappingURL=playlist-add.js.map
